const unescape = (v) => v.replace(/\\n/gi, " ").replace(/\\([,;\\])/g, "$1").trim();

function unfold(text) {
  return text.replace(/\r\n/g, "\n").replace(/=\n/g, "").replace(/\n[ \t]/g, "");
}

function decodeQP(v) {
  const bytes = [];
  for (let i = 0; i < v.length; i++) {
    if (v[i] === "=" && /^[0-9A-F]{2}$/i.test(v.slice(i + 1, i + 3))) { bytes.push(parseInt(v.slice(i + 1, i + 3), 16)); i += 2; }
    else bytes.push(v.charCodeAt(i));
  }
  return new TextDecoder("utf-8").decode(new Uint8Array(bytes));
}

export function parseVCards(text) {
  const out = [];
  const blocks = unfold(text).split(/BEGIN:VCARD/i).slice(1);
  for (const block of blocks) {
    const c = { name: "", title: "", company: "", phone: "", phone2: "", email: "", email2: "", website: "", address: "", notes: "" };
    const phones = [];
    const emails = [];
    let structuredName = "";
    for (const raw of block.split("\n")) {
      const idx = raw.indexOf(":");
      if (idx < 0) continue;
      const keyPart = raw.slice(0, idx).toUpperCase();
      const rawVal = raw.slice(idx + 1);
      const val = keyPart.includes("QUOTED-PRINTABLE") ? decodeQP(rawVal) : rawVal;
      const key = keyPart.split(";")[0].replace(/^ITEM\d+\./, "");
      if (key === "FN") c.name = unescape(val);
      else if (key === "N") {
        const [last = "", first = ""] = val.split(";");
        structuredName = `${unescape(first)} ${unescape(last)}`.trim();
      } else if (key === "ORG") c.company = unescape(val.split(";")[0]);
      else if (key === "TITLE") c.title = unescape(val);
      else if (key === "TEL") phones.push(unescape(val));
      else if (key === "EMAIL") emails.push(unescape(val));
      else if (key === "URL" && !c.website) c.website = unescape(val);
      else if (key === "ADR" && !c.address) c.address = val.split(";").map(unescape).filter(Boolean).join(", ");
      else if (key === "NOTE") c.notes = unescape(val);
    }
    if (!c.name) c.name = structuredName;
    [c.phone = "", c.phone2 = ""] = phones;
    [c.email = "", c.email2 = ""] = emails;
    if (c.name || c.phone || c.email || c.company) out.push(c);
  }
  return out;
}

function parseCSVRows(text) {
  const rows = [];
  let row = [];
  let cur = "";
  let q = false;
  const src = text.replace(/^\uFEFF/, "").replace(/\r\n?/g, "\n");
  for (let i = 0; i < src.length; i++) {
    const ch = src[i];
    if (q) {
      if (ch === '"' && src[i + 1] === '"') { cur += '"'; i++; }
      else if (ch === '"') q = false;
      else cur += ch;
    } else if (ch === '"') q = true;
    else if (ch === ",") { row.push(cur.trim()); cur = ""; }
    else if (ch === "\n") { row.push(cur.trim()); rows.push(row); row = []; cur = ""; }
    else cur += ch;
  }
  row.push(cur.trim());
  rows.push(row);
  return rows.filter((r) => r.some((c) => c));
}

const CSV_MAP = [
  ["name", /^(full ?name|name|display name)$/i],
  ["first", /^(first ?name|given name)$/i],
  ["last", /^(last ?name|family name|surname)$/i],
  ["company", /^(company|organization|organisation|organization 1 - name|org)$/i],
  ["title", /^(title|job title|organization 1 - title)$/i],
  ["phone", /^(phone|mobile|mobile phone|phone 1 - value|primary phone)$/i],
  ["phone2", /^(phone ?2|work phone|business phone|phone 2 - value)$/i],
  ["email", /^(email|e-mail|email address|e-mail address|e-mail 1 - value)$/i],
  ["email2", /^(email ?2|e-mail 2 address|e-mail 2 - value)$/i],
  ["website", /^(website|web page|url|website 1 - value)$/i],
  ["industry", /^industry$/i],
  ["address", /^(address|business address|address 1 - formatted)$/i],
  ["notes", /^(notes?)$/i],
];

export function parseCSV(text) {
  const rows = parseCSVRows(text);
  if (rows.length < 2) return [];
  const cols = rows[0].map((h) => (CSV_MAP.find(([, re]) => re.test(h)) || [null])[0]);
  return rows.slice(1).map((cells) => {
    const c = {};
    cols.forEach((k, i) => { if (k && cells[i] && !c[k]) c[k] = cells[i]; });
    if (!c.name) c.name = `${c.first || ""} ${c.last || ""}`.trim();
    delete c.first; delete c.last;
    return c;
  }).filter((c) => c.name || c.phone || c.email || c.company);
}

export const canPickContacts = () =>
  typeof navigator !== "undefined" && "contacts" in navigator && "ContactsManager" in window;

export async function pickPhoneContacts(multiple = true) {
  const picked = await navigator.contacts.select(["name", "email", "tel"], { multiple });
  return picked.map((p) => ({
    name: (p.name && p.name[0]) || "",
    phone: (p.tel && p.tel[0]) || "",
    phone2: (p.tel && p.tel[1]) || "",
    email: (p.email && p.email[0]) || "",
    email2: (p.email && p.email[1]) || "",
  })).filter((c) => c.name || c.phone || c.email);
}
